import type { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { isValidDateString } from './is-valid-date-string';

/**
 * Parses an MM/DD/YYYY string into an NgbDateStruct, or null
 * if invalid.
 */
export function parseToDateStruct(value: string): NgbDateStruct | null {
  if (!isValidDateString(value)) {
    return null;
  }
  const [month, day, year] = value.split('/').map(Number);
  return { year, month, day };
}
